import styled from 'styled-components';

/* Otoczka dla podpowiedzi: wyłączony przycisk nie zgłasza najechania. */
export const TooltipAnchor = styled.span`
  display: inline-flex;
`;

/* Ta sama mała ikona co w akcjach wierszy list punktów (ustawienia, edycja). */
export const RowIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  background: transparent;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};

  &:hover:not(:disabled) {
    background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#f9fafb')};
    border-color: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#d1d5db')};
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  svg { width: 14px; height: 14px; }
`;
